var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "DashboardIcon",
    d: "M7,20H17M9,16v4m6-4v4M8,12l3-3,2,2,3-3M3,5A1,1,0,0,1,4,4H20a1,1,0,0,1,1,1V15a1,1,0,0,1-1,1H4a1,1,0,0,1-1-1Z",
    transform: "translate(-2 -3)",
    fill: "none",
    stroke: "#212121",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIconDark);
export default __webpack_public_path__ + "static/media/DashboardIconDark.a7b2f2bbc60f72aa6114e241f6c9f52e.svg";
export { ForwardRef as ReactComponent };